import * as React from "react"
import { SVGProps } from "react"

const SvgCloseBold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 96 960 960" {...props}>
    <path d="M480 631.566 276.783 834.783Q264.957 846.609 249 846.609t-27.783-11.826T209.391 807t11.826-27.783L424.434 576 221.217 372.783Q209.391 360.957 209.391 345t11.826-27.783T249 305.391t27.783 11.826L480 520.434l203.217-203.217q11.826-11.826 27.783-11.826t27.783 11.826T750.609 345t-11.826 27.783L535.566 576l203.217 203.217q11.826 11.826 11.826 27.783t-11.826 27.783T711 846.609t-27.783-11.826z" />
  </svg>
)
export default SvgCloseBold
